import { Navigate, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useEffect, useState } from "react";
import { getBestSellerProduct, IGetBestSellerProductPayload } from "../../../redux/actions/customizer";
import { toast } from "react-toastify";
import If from "../../components/If";
import Loading from "../../components/Shared/Loader";
import { RootState } from "../../../redux/store";
import { useRingCustomizerContext } from "../../context/RingCustomizerContext";


const BestSeller = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const { bestSellerProduct, isFetching } = useAppSelector((state: RootState) => state.customizer);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if(params?.id) {
      fetchBestSellerProduct(params.id);
    }
  }, [params?.id]);

  const fetchBestSellerProduct = async(id: string) => {
    try {
      const payload: IGetBestSellerProductPayload = {
        id,
        data: {
          size: searchParams.get('size') || '',
          engraving: searchParams.get('engraving') || '',
          subpath: params.subpath || '',
        }
      };
      await dispatch(getBestSellerProduct(payload)).unwrap();
    } catch(error: any) {
      setMessage(error?.message)
      toast.error(error?.message);
    }
  }

  return (
    <>
      <If condition={isFetching}>
        <Loading timedOut={isFetching}/>
      </If>
      {/* Here when data is loaded  and id is same then redirect */}
      <If condition={!isFetching && bestSellerProduct?.bestseller_id === params?.id}>
        <Navigate to={`/${params.pathprefix}/${params.subpath}${bestSellerProduct?.ring_options_url}&bestSeller=${params.id}&bSize=${searchParams.get('size')}&bEngraving=${searchParams.get('engraving')}`}/>
      </If>
      <If condition={!isFetching && !bestSellerProduct}>
        <section className="tw-flex tw-flex-col tw-items-center tw-justify-center secondary-font-family tw-mt-2 tw-h-2/3">
          <i className="fa fa-times-circle-o tw-text-3xl tw-text-red-600" aria-hidden="true" />
          <h2 className="tw-mb-0 tw-text-xl tw-font-bold">{message}</h2>
        </section>
      </If>
    </>
  );
}

export default BestSeller;